import React, { useEffect } from 'react';
import {
  StyledButtonsContainer,
  StyledConfirmationWrapper,
  StyledContent,
  StyledSubtitle,
} from '../styles/confirmation-styles';
import {
  Breakpoints,
  CTA,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import { useMyVwContext } from '../../../shared/hooks/use-my-vw-context';
import { useHistory } from '../../../shared/hooks/use-history';
import { useTrackingManager } from '../../../shared/hooks/use-tracking-manager';
import {
  onVWBasicButtonClickEvent,
  onVWBasicFormSubmissionSuccessMessageLoadEvent,
} from '../../../shared/tagging/tagging-helpers';
import { useUser } from '../../../app/providers/UserContext';

export const Confirmation: React.FC = () => {
  const { translationHandler } = useMyVwContext();
  const { user } = useUser();
  const history = useHistory();
  const trackingManager = useTrackingManager();

  const handleStepLoadTracking = () => {
    onVWBasicFormSubmissionSuccessMessageLoadEvent(trackingManager, {});
  };

  const handleAddVehicleTracking = () => {
    onVWBasicButtonClickEvent(trackingManager, {
      Type: 'Button',
      Name: translationHandler('registration.success.cta.addVehicle'),
      ItemCount: 2,
      ItemPosition: 1,
    });
  };

  const handleGoToMyAccountTracking = () => {
    onVWBasicButtonClickEvent(trackingManager, {
      Type: 'Button',
      Name: translationHandler('registration.success.cta.myAccount'),
      ItemCount: 2,
      ItemPosition: 2,
    });
  };

  const handleAddVehicle = () => {
    handleAddVehicleTracking();
    history.push('/vehicle-management');
  };
  const handleMyAccount = () => {
    handleGoToMyAccountTracking();
    history.push('/account-settings');
  };

  useEffect(() => {
    handleStepLoadTracking();
  }, []);

  return (
    <StyledConfirmationWrapper className="confirmation-wrapper">
      <StyledContent>
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize28,
              color: TextColor.primary,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight32,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize32,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {`${translationHandler('registration.success.title')}, ${user?.firstName ?? ''}`}
        </TextCustom>

        <TextCustom
          appearance={TextAppearance.headline300}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize24,
              color: TextColor.primary,
              fontWeight: TextWeight.light,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
            [Breakpoints.b560]: {
              fontSize: TextSize.TextSize28,
              lineHeight: TextLineHeight.TextLineHeight32,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize32,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          <StyledSubtitle>
            {translationHandler('registration.success.subtitle')}
          </StyledSubtitle>
        </TextCustom>
        <TextCustom
          appearance={TextAppearance.headline300}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight32,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize24,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {translationHandler('registration.success.description')}
        </TextCustom>
      </StyledContent>
      <StyledButtonsContainer>
        <CTA
          aria-label="Submit button"
          emphasis="primary"
          stretchContent
          tag="button"
          type="submit"
          onClick={handleAddVehicle}
        >
          {translationHandler('registration.success.cta.addVehicle')}
        </CTA>
        <CTA
          aria-label="Submit button"
          emphasis="secondary"
          stretchContent
          tag="button"
          type="submit"
          onClick={handleMyAccount}
        >
          {translationHandler('registration.success.cta.myAccount')}
        </CTA>
      </StyledButtonsContainer>
    </StyledConfirmationWrapper>
  );
};